import { Link } from "react-router-dom";

export default function Admissions({ section, items = [] }) {
  if (!section || section.is_enabled === 0) return null;

  return (
    <section className="admissions section" aria-label="Admissions process">
      <div className="section__inner">
        <div className="section__header">
          {section.badge && <span className="section__tag">{section.badge}</span>}
          <h2 className="section__title">{section.title}</h2>
          {section.subtitle && <p className="section__subtitle">{section.subtitle}</p>}
        </div>

        <div className="admissions__steps">
          {items.map((item, index) => (
            <div key={item.id} className="admission-step">
              <div className="admission-step__number">{item.subtitle || String(index + 1).padStart(2, "0")}</div>
              {index < items.length - 1 && <div className="admission-step__connector" aria-hidden="true" />}
              <h3 className="admission-step__title">{item.title}</h3>
              <p className="admission-step__desc">{item.body}</p>
            </div>
          ))}
        </div>

        <div className="admissions__cta">
          {section.button_text && section.button_link && (
            <Link to={section.button_link} className="btn btn--filled btn--lg">{section.button_text}</Link>
          )}
          {section.secondary_button_text && section.secondary_button_link && (
            <Link to={section.secondary_button_link} className="btn btn--ghost btn--lg">{section.secondary_button_text}</Link>
          )}
        </div>
      </div>
    </section>
  );
}
